<template>
  <section class="dte-card">
    <div class="dte-card__header">Totales</div>
    <div class="dte-card__body">
      <div class="dte-summary__stack">
        <div v-if="showMetaChips" class="dte-chip-row" style="margin-bottom: 2px;">
          <span v-if="showPaymentStatusChip" class="dte-chip">{{ paymentStatusLabel }}: {{ isContadoEspecial ? "Cancelada / Contado" : documentData.meta.paymentStatus }}</span>
          <span v-if="showCurrencyChip" class="dte-chip">{{ currencyLabel }}: {{ documentData.meta.currency }}</span>
        </div>
        <div v-if="documentData.amountInWords" class="dte-total-row">
          <span><strong>Valor en letras</strong></span>
          <span>{{ documentData.amountInWords }}</span>
        </div>
        <div
          v-for="(row, index) in documentData.totalRows"
          :key="`${row.key || row.label}-${index}`"
          class="dte-total-row"
          :class="{ 'is-emphasis': row.emphasis }"
        >
          <span>{{ row.displayLabel || row.label }}</span>
          <span>{{ row.value }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { getDteTemplateLabel, isDteTemplateFieldVisible } from "@/helpers/dteTemplateSettings";

export default {
  name: "DteTotalsSection",
  props: {
    documentData: {
      type: Object,
      required: true,
    },
  },
  computed: {
    templateSettings() {
      return this.documentData.templateSettings || {};
    },
    showPaymentStatusChip() {
      return (
        Boolean(this.documentData.meta.paymentStatus) &&
        isDteTemplateFieldVisible(this.templateSettings, "receiver", "paymentStatus")
      );
    },
    showCurrencyChip() {
      return (
        Boolean(this.documentData.meta.currency) &&
        isDteTemplateFieldVisible(this.templateSettings, "receiver", "currency")
      );
    },
    showMetaChips() {
      return this.showPaymentStatusChip || this.showCurrencyChip;
    },
    paymentStatusLabel() {
      return getDteTemplateLabel(this.templateSettings, "paymentStatus", "Estado");
    },
    currencyLabel() {
      return getDteTemplateLabel(this.templateSettings, "currency", "Moneda");
    },
    isContadoEspecial() {
      const diasCredito = this.diferentBetweenDays(
          this.documentData.meta.issueDate,
          this.documentData.meta.dueDate
      );

      const user = JSON.parse(localStorage.getItem("user") || "{}");

      return (
        user?.showcashinvoiceswhen1day &&
        this.documentData?.meta?.paymentStatus === "Crédito" &&
        diasCredito === 1
      );
    },
  },
  methods: {
    diferentBetweenDays(date1, date2) {
        const [d1, m1, a1] = date1.split('/').map(Number);
        const [d2, m2, a2] = date2.split('/').map(Number);

        const f1 = new Date(a1, m1 - 1, d1);
        const f2 = new Date(a2, m2 - 1, d2);

        const diferenciaMs = Math.abs(f2 - f1);
        return Math.floor(diferenciaMs / (1000 * 60 * 60 * 24));
    }
  }
};
</script>
